// extracted by mini-css-extract-plugin
module.exports = {"row":"AddKidsTableRow_row__2ItRE","col":"AddKidsTableRow_col__3uUk_","delete":"AddKidsTableRow_delete__3yI_v"};